
import type { ColorVariant } from '@lgc/database/types/domains/subscription';

export type GradientVariant = ColorVariant

export const gradientVariants: Record<GradientVariant, { color1: string; color2: string }> = {
  beige: { color1: '#6B6452', color2: '#D2CBB6' },
  gold: { color1: '#8B621C', color2: '#EDE895' },
  diamond: { color1: '#0A0D12', color2: '#717680' },
  platinum: { color1: '#616161', color2: '#8C8C8C' },
  purple: { color1: '#7F56D9', color2: '#D6BBFB' },
  aqua: { color1: '#346870', color2: '#6FDEF0' },
  // silver: { color1: '#E6E9F0', color2: '#EEF1F5' },
  blue: { color1: '#09203F', color2: '#537895' },
  green: { color1: '#0D2820', color2: '#7FB7A4' },
  red: { color1: '#3E091B', color2: '#B56A82' },
}

export type GradientDirection =
  | 'right'
  | 'left'
  | 'top'
  | 'bottom'
  | 'top-right'
  | 'top-left'
  | 'bottom-right'
  | 'bottom-left'

export const gradientDirectionCss: Record<GradientDirection, string> = {
  right: 'to right',
  left: 'to left',
  top: 'to top',
  bottom: 'to bottom',
  'top-right': 'to top right',
  'top-left': 'to top left',
  'bottom-right': 'to bottom right',
  'bottom-left': 'to bottom left',
}
